import cn from 'classnames';
import React, {ComponentPropsWithoutRef, FC} from 'react';

import {useFieldContext} from '@/components/AppForm/context';
import AriaLiveContainer from '@/components/AriaLiveMessage/AriaLiveContainer';

interface IFieldWarningLabelProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {}

export const FieldWarningMessage: FC<IFieldWarningLabelProps> = ({className}) => {
    const {warningMessageId, warningMessage} = useFieldContext();

    if (!warningMessage) {
        return null;
    }

    return (
        /*@ts-ignore*/
        <AriaLiveContainer
            // Cant use twx, because it removes text- classes
            className={cn('mt-1 text-start text-14 leading-[24px] text-error', className)}
            alert
            visible
            id={warningMessageId}
        >
            {warningMessage}
        </AriaLiveContainer>
    );
};
